import {Curricula} from "../../../routes/curricula/Curricula";

export const sidebarLinks: SidebarLink[] = [
  {
    route: "/",
    label: "Content",
    icon: "fa fa-home",
  },
  {
    route: "/settings",
    label: "Settings",
    icon: "fa fa-cog",
  },
  {
    route: "/seminars",
    label: "Seminar List",
    icon: "fa fa-calendar",
  },
  {
    route: "/curriculaList",
    label: "Curriculum List",
    icon: "fa fa-calendar",
  },
  {
    route: "/communities",
    label: "Community List",
    icon: "fa fa-chalkboard-teacher",
  },
  {
    route: "/curricula",
    label: "Curricula Module",
    icon: "fa fa-chalkboard-teacher",
  },
  {
    route: "/shihr",
    label: "SHI-HR Module",
    icon: "fa fa-chalkboard-teacher",
  },
  {
    route: "/courses",
    label: "Course",
    icon: "fa fa-book",
  },
  {
    route: "/users",
    label: "Users",
    icon: "fa fa-user",
  },
  {
    route: "/activity",
    label: "Activity",
    icon: "fas fa-chart-line",
  },
  {
    route: "/help",
    label: "Help",
    icon: "fa fa-question-circle",
  },
  {
    route: "/system-logs",
    label: "System Logs",
    icon: "fas fa-cogs",
  }
];

export interface SidebarLink {
  route: string;
  label: string;
  icon?: string;
  badge?: number;
  subMenu?: SidebarLink[];
}
